import React from 'react';
import _ComplaintForm from './_ComplaintForm.scss';
import {SingleImageUploader} from 'components/uploader';
import {Textarea} from 'components/vitrade-forms/common';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {Complains} from 'api';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';
import Select from 'react-select';

class ComplaintForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      image: '',
      content: '',
      isSubmit: false
    };
    this.props.validators['formComplaint'] = [];
    this.onUploadComplete = this.onUploadComplete.bind(this);
    this.removeImage = this.removeImage.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  validateSubmitForm() {
    let isValid = true;
    this.props.validators['formComplaint'].map(validator => {
      if (isValid) {
        isValid = validator.validate();
      } else {
        validator.validate();
      }
    });
    if (!isValid) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }
    return isValid;
  }

  onUploadComplete(image) {
    this.setState({image: image.name});
  }

  removeImage() {
    this.setState({image: ''});
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      const {image, content} = this.state;
      const data = {image, content};
      this.setState({isSubmit: true});
      Complains.actions.add.request({}, {data}).then(response => {
        this.setState({isSubmit: false});
        toastr.success('Thành công!', 'Gửi khiếu nại thành công.');
        this.props.history.push('/user/complains');
      }).catch(error => {
        this.setState({isSubmit: false});
      });
    }
  }

  render() {
    const {image, content, isSubmit, categories} = this.state;
    return (
      <div className="row">
        <form method="POST" onSubmit={this.onSubmit} noValidate>
          <div className="user-form-wrap">
            <SingleImageUploader fnUpload={Complains.actions.uploadImage.request}
              title="Hình ảnh đính kèm"
              type="COMPLAIN"
              image={image}
              onRemoveImage={this.removeImage}
              onUploadComplete={this.onUploadComplete}
              confirmRemove={true}
            />
            <div className="box-wrap box-padding-20">
              <div className="complaint-content-wrap">
                <p className="box-header">Nội dung</p>
                <p className="form-warning">
                  <i className="fa fa-exclamation-circle"></i>
                  Giới hạn trong 1000 chữ.
                </p>
              </div>
              <Textarea type="text" placeholder="Nội dung yêu cầu..."
                className="contact-form-group"
                inputClassName="complaint-content"
                required={true}
                rows={20}
                maxLength={1000}
                name="content"
                value={content}
                onChange={this.onChange}
                bindValidator={this} channel="formComplaint"
                errorMessage="Bạn vui lòng nhập mô tả ngắn"/>
            </div>
          </div>
          <div className="select-category-wrap">
            <div className="box-wrap box-padding-20">
              <p className="box-header">Gửi khiếu nại</p>
              <LaddaButton className="update-btn" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Gửi đi</LaddaButton>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

ComplaintForm.defaultProps = {
  validators: {}
};

export default withRouter(ComplaintForm);



// WEBPACK FOOTER //
// ./components/users/sub-view/complaint-form/ComplaintForm.jsx